import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

export default class DiffAdu extends Component {
  // Services
  // ~~~~~

  @service intl;

  // Properties
  // ~~~~~

  get hasAduHorizon() {
    let { from, to } = this.args;
    return from?.aduHorizon !== null || to?.aduHorizon !== null;
  }

  get fromHorizonFormatted() {
    return this._formatHorizon(this.args.from?.aduHorizon);
  }

  get toHorizonFormatted() {
    return this._formatHorizon(this.args.to?.aduHorizon);
  }

  get hasAduHorizonOffset() {
    return this.args.from?.aduHorizonOffset !== null || this.args.to?.aduHorizonOffset !== null;
  }

  get fromHorizonOffsetFormatted() {
    return this._formatHorizon(this.args.from?.aduHorizonOffset);
  }

  get toHorizonOffsetFormatted() {
    return this._formatHorizon(this.args.to?.aduHorizonOffset);
  }

  // Private Helpers
  // ~~~~~
  _formatHorizon(aduHorizon) {
    return aduHorizon ? this.intl.t('daysCount', { value: aduHorizon }) : this.intl.t('none');
  }
}
